module.exports = __webpack_public_path__ + "img/big_kegs.b79a3697.svg";